export default "__VITE_ASSET__u$tExmZl__"